module.exports = __webpack_public_path__ + "static/event3-d2571dff98c8dac75e60a0c5d1854400.jpg";